query classroomsFilter($scenarioId: ID!, $filterId: ID, $pagination: PaginationInput) {
  filter(scenarioId: $scenarioId) {
    classrooms(filterId: $filterId, pagination: $pagination) {
      items {
        id
        code
        name
        usable
        capacity
        floor
        classroomType {
          code
          __typename
        }
        building {
          code
          name
          __typename
          campus {
            code
            __typename
          }
        }
        __typename
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        page
        size
        total
        __typename
      }
      __typename
    }
    __typename
  }
}
